var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdaptableDesign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_57)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.9998 112.893V36.1373C25.5666 35.0375 25.4693 33.6755 26.0996 32.931C34.2257 41.0609 42.3348 49.1738 50.3847 57.2275C49.5006 57.2275 48.3881 57.2105 47.2798 57.2275C44.5979 57.2782 42.5759 59.1859 42.5844 61.6308C42.5929 64.0841 44.6064 65.996 47.301 66.0129C51.9879 66.0425 56.6749 66.0468 61.3619 66.0129C64.0988 65.9918 65.9854 64.1391 66.0108 61.4235C66.0573 56.6903 66.0531 51.9528 66.0108 47.2196C65.9896 44.5505 63.9888 42.5329 61.548 42.5878C59.1411 42.6428 57.2883 44.6182 57.2291 47.2196C57.2037 48.3659 57.2248 49.5122 57.2248 50.5569C49.0565 42.3933 40.9389 34.2804 32.8213 26.1674C34.5641 25.2834 36.5522 25 38.6292 25C79.5387 25.0127 120.448 25.0085 161.358 25.0085C169.353 25.0085 174.991 30.6469 174.996 38.6329C175.004 50.1551 174.996 61.6731 174.996 73.1953V74.8661C170.617 72.2308 165.968 72.4381 161.336 72.4508C149.475 72.4762 137.61 72.4508 125.749 72.4635C115.338 72.4762 107.627 80.1872 107.61 90.5928C107.597 97.4282 107.563 104.259 107.644 111.095C107.661 112.546 107.335 112.935 105.833 112.931C78.8873 112.88 51.9372 112.897 24.9913 112.897L24.9998 112.893Z",
    fill: "url(#paint0_linear_75_57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.439 175C123.041 174.581 122.462 174.611 121.975 174.416C118.655 173.088 116.421 169.933 116.421 166.367C116.409 140.882 116.413 115.397 116.421 89.9116C116.421 89.2898 116.316 88.63 116.612 88.2493C123.549 95.1821 130.499 102.132 137.407 109.035C136.641 109.229 135.533 109.048 134.45 109.073C131.646 109.136 129.594 110.981 129.598 113.481C129.598 115.989 131.646 117.863 134.454 117.871C139.044 117.888 143.634 117.892 148.223 117.871C151.134 117.854 153.008 116.014 153.029 113.134C153.058 108.498 153.054 103.858 153.029 99.2174C153.012 96.4426 151.053 94.3826 148.562 94.4376C146.1 94.4926 144.281 96.5018 144.239 99.2174C144.222 100.288 144.239 101.358 144.239 102.14C137.407 95.2878 130.457 88.3212 123.507 81.3546C123.739 81.1346 124.404 81.2658 125.013 81.2615C138.828 81.2531 152.648 81.2361 166.464 81.2615C171.091 81.27 174.979 85.1319 174.983 89.7551C175.008 115.337 175 140.92 174.983 166.502C174.983 169.966 172.707 173.096 169.433 174.408C168.947 174.602 168.367 174.573 167.97 174.991H123.435L123.439 175Z",
    fill: "url(#paint1_linear_75_57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 121.683C51.9374 121.683 78.8706 121.7 105.808 121.657C107.229 121.657 107.699 121.915 107.661 123.451C107.542 128.23 107.568 133.014 107.652 137.794C107.673 139.063 107.272 139.283 106.1 139.283C83.6041 139.249 61.1083 139.258 38.6125 139.254C31.8274 139.254 26.8866 135.316 25.2496 128.649C25.203 128.467 25.0846 128.302 25.0042 128.129C25.0042 125.98 25.0042 123.831 25.0042 121.683H25Z",
    fill: "url(#paint2_linear_75_57)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.7538 175C69.4924 173.282 68.8748 171.675 70.0719 168.067C70.8714 165.664 71.6498 163.258 72.4662 160.859C73.308 158.393 74.6658 157.433 77.2631 157.425C79.6066 157.42 81.9501 157.391 84.2936 157.442C85.11 157.458 85.3934 157.23 85.3765 156.38C85.3257 154.037 85.4061 151.693 85.3384 149.35C85.3088 148.364 85.5288 148.013 86.6032 148.022C93.1938 148.072 99.7843 148.072 106.375 148.022C107.441 148.013 107.652 148.36 107.64 149.346C107.593 154.421 107.673 159.497 107.597 164.573C107.542 168.257 108.198 171.739 109.966 174.991H72.7581L72.7538 175Z",
    fill: "url(#paint3_linear_75_57)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_57",
    x1: 99.9953,
    y1: 25,
    x2: 99.9953,
    y2: 112.931,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_75_57",
    x1: 145.701,
    y1: 81.2266,
    x2: 145.701,
    y2: 175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_75_57",
    x1: 66.3314,
    y1: 121.657,
    x2: 66.3314,
    y2: 139.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_75_57",
    x1: 89.7363,
    y1: 148.021,
    x2: 89.7363,
    y2: 175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_57"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(25 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdaptableDesign);
export default __webpack_public_path__ + "static/media/Adaptable_Design.08c2298ca1117bd94a619f59d3a36e80.svg";
export { ForwardRef as ReactComponent };